import { Flex } from "@chakra-ui/react";
import "bootstrap/dist/css/bootstrap.css";
import { useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { baseURL } from "../../../services/api";
import MuralApi from "../../../services/MuralApi";

export interface BannerList {
  ativo: boolean;
  url: string;
}

export default function CarouselComponent() {
  const [images, setimages] = useState(Array<BannerList>);

  async function getImages() {
    try {
      const response = await MuralApi.getImages();
      setimages(response);
      // console.log("response", response);
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    getImages();
  }, []);

  return (
    // O banner acompanha a coluna lateral em vez de ter largura fixa de 600px:
    // em 4:3 ele estourava a coluna e em ultrawide sobrava espaço morto.
    <Flex w={"100%"} justifyContent={"center"}>
      <div style={{ display: "block", width: "100%", maxWidth: 420 }}>
        <Carousel fade controls={false} prevIcon={"prevIcon"}>
          {images &&
            images.map((item, index) => {
              const url = item && item.url.split("api")[1];

              return (
                <Carousel.Item key={index} interval={5000}>
                  <img
                    src={item && `${baseURL}${url}`}
                    alt={`Image ${index}`}
                    style={{
                      // altura fluida com piso e teto: em tela baixa (ultrawide
                      // 1080p) não come a coluna toda, em tela alta não estica
                      width: "100%",
                      height: "clamp(240px, 46vh, 520px)",
                      objectFit: "contain",
                      overflow: "hidden",
                    }}
                  />
                </Carousel.Item>
              );
            })}
        </Carousel>
      </div>
    </Flex>
  );
}
